import { render } from "./TopMenu.vue?vue&type=template&id=2c06e7e8&scoped=true"
import script from "./TopMenu.vue?vue&type=script&lang=js"
export * from "./TopMenu.vue?vue&type=script&lang=js"

import "./TopMenu.vue?vue&type=style&index=0&id=2c06e7e8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1770878715/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c06e7e8"]])

export default __exports__